export const toSlug = (text = "") => {
  if (!text) return "";
  return text.toString().toLowerCase().trim().replace(/[\s\W-]+/g, "-").replace(/^-+|-+$/g, "");
};